// import { FluentResource } from '@fluent/bundle';
// declare var FluentResource: any

let FluentResource = window["FluentBundle"].FluentResource;

// XXX: store messages also by area (with shared identifiers, thus "mutually exclusive")
//      and only load the given "area" translation file

// Store all translations as a simple object which is available
// synchronously and bundled with the rest of the code.
export const RESOURCES = {
    'cs': new FluentResource(`
choose-fav = Vybrat oblíbené „knihy“ a kategorie
# common identifier in a per-area (per VW module) file: select-favorite-items-and-groups
select-favorite-dictionaries-and-groups = Oblíbené
select-favorite-editions-and-groups = Oblíbené
# yep, this was too verbose:
# Označit/použít [pro účel vyhledávání] oblíbené slovníky/edice a jejich „skupiny/kategorie“

filter-by-name =
    .placeholder = Filtrovat podle názvu, zkratky, …
`),
    'en': new FluentResource(`
select-favorite-dictionaries-and-groups = Select favorite dictionaries

filter-by-name =
    .placeholder = Filter by name, abbreviation, …
`),
};
